<app-search-bar
  [isMobile]="isMobile$ | async"
  [searchType]="searchType"
  [airports]="airports$ | async"
  [source]="source"
  [loadDefaultplaces]="loadDefaultplaces"
  (showMobileCalendarEvent)="showMobileCalendar($event)">
</app-search-bar>

<router-outlet name="search"></router-outlet>